import pic_01 from './Assets/pic_01.webp';
import pic_02 from './Assets/pic_02.webp';
import pic_03 from './Assets/pic_03.webp';
import pic_04 from './Assets/pic_04.webp';
import pic_05 from './Assets/pic_05.webp';
import ambassadorImage from './Assets/NemRaps.webp'

export const ambassador = {
  name: 'NemRaps',
  position: 'left',
  description: <>
    <p>
      NemRaps is a YouTube content creator and social media personality who is recognized for reacting to trending memes and making hip hop comedy songs. His personal YouTube channel has over 450,000 subscribers to date. Combining his love for music and pop culture, Nem took the leap to become a full-time online creator in 2013. Growing up in the 80's, Nem realized his passion for making funny skits and music videos while "borrowing" the family's camcorder. He's always had a knack for entertaining and creating with the ultimate goal of putting a smile on people's faces
    </p>
  </>,
  image: ambassadorImage,
  socialLinks: {
    instagram: 'https://www.instagram.com/nemraps/#',
    youtube: 'https://www.youtube.com/nemraps',
    twitter: 'https://x.com/NemRaps?mx=2',
    tiktok: 'https://www.tiktok.com/@nemraps',
  },
};

export const EpochInfo = {
  title: 'MYSPACISM',
  period: '2003 - 2006',
  description: <>
    <p>
      MySpace sparked a vibrant revolution in the early 2000s blogging across Europe and America. It was a place where writers could fully express their unique identities, embracing imagination, creativity, and the art of HTML design. This dynamic era was all about making a statement, forging communities, and connecting with others online. Though its time was short-lived, MySpace’s influence continues to resonate, shaping how we share our voices and stories on the web today.
    </p>
  </>,
};

export const events = [
  {
    year: '2003',
    title: 'Jeffrey Starr’s Blog',
    content: (
      <>
        <p>
          Jeffrey Star was a MySpace superstar back in the day, and that’s where his blogging journey really took off. In November 2006, he was even named the most popular person on MySpace. By October 2007, he had an astounding 632,000 friends on his profile, and every new photo could rack up 50,000 comments.
        </p>
      </>
    ),
    img: pic_01,
    blurhash: '|MG@iSNIMwkox]nOW;n+WB}[s:9sODt7a}xasoS1Q.s8xtniV[t6ofsBR*nOOWkDOCi|SeX5fRoLNZR-jbI:sDoMXQs:s.OAoexbSeaLN[odbHWBWYX8oNShkCR*WCjaR+t6njjFX7ofj@aeWCoLNtoLR+W;W.R+oJR*o3',
    picName: 'pic_01',
  },
  {
    year: '2004',
    title: 'Ascent to Orbit',
    content: (
      <>
        <p>
          R.E.M., the legendary rock band, dropped their album on MySpace, and it really helped skyrocket their popularity. This not only drew in a new wave of fans but also prompted major music brands to invest time and resources into their MySpace profiles. Inspired by R.E.M.’s success, indie musicians began launching their own blogs on the platform, hoping to catch the attention of listeners and grow their audiences.
        </p>
      </>
    ),
    img: pic_02,
    blurhash: '|7HT]RMM4qnOtRBCt+Z$^h_MtRTKH@mlm-NhERe958-,9trEMxMf0h%KxD]|$f9}}?I:EMrWTcxZ56xaW@s;%1D,IWS|=sqwadr=-CRjx?W=-7smofv#Mg$yo}xHxHNwt7w5NgXSnMtRcXxuIVO?E+xsR%E3Sw$%xoadxE',
    picName: 'pic_02',
  },
  {
    year: '2004',
    title: 'The Largest Advertising Integration',
    content: (
      <>
        <p>
          In 2004, Myspace quickly became a go-to spot for musicians, thanks to... an advertising campaign. In December, users could download three free Hilary Duff tracks by visiting the Secret Sparkle deodorant page. The response was massive, and soon after, musicians began actively promoting their music on the platform.
        </p>
      </>
    ),
    img: pic_04,
    blurhash: '|MIXBYE2Z*t1VrE2E4oLxc~V9cMeXm-Qt7bYWYOYrXrs#7s;$%XSo{WVSxJ8w[-QWBWGNdRoV@Iroxs*%1t6NHS%bEV[Nyohv~JDs:R:J.xBS$xWbcRjbvs.J:kBnhSzi{bbS$oyf6JonhWBn#R-nNNwj=WBbunhSga#R.',
    picName: 'pic_03',
  },
  {
    year: '2005',
    title: 'Myspace Tom',
    content: (
      <>
        <p>
          Tom, the co-founder of Myspace, once had the most popular account on the platform — not by creating bots or flashy posts, but simply by being the friend of every user! While some tried to unfriend him, their efforts were in vain. His profile picture hasn’t changed since the platform launched. Now, you can find him on Tom Andersen’s Instagram, where he shares his adventures as a travel photographer, living life on his own terms after Myspace's high-profile failure.
        </p>
      </>
    ),
    img: pic_03,
    blurhash: '|AKmtg0L00%N00a6s=xBMx{]-p^iWBkWR5WZ-U4n00?G?aVqNyE2i_IWxYTfVtMx-.IApIiwM|~UtRIqa0%K-UxsxWMxNH$dJ8oII[NKRj%faJoz=?S}Rj9wX9o}Ej%LRi%1oHkqIVM|S$NaoynhXonhIp-UNeXSV@o|$*',
    picName: 'pic_04',
  },
  {
    year: '2006',
    title: 'Life-Changing Viral Video',
    content: (
      <>
        <p>
          Adele's music career took off after a friend posted a video of her singing on Myspace. The video went viral, catching the attention of XL Recordings, who quickly offered her a record deal.
        </p>
      </>
    ),
    img: pic_05,
    blurhash: '|MIXBYE2Z*t1VrE2E4oLxc~V9cMeXm-Qt7bYWYOYrXrs#7s;$%XSo{WVSxJ8w[-QWBWGNdRoV@Iroxs*%1t6NHS%bEV[Nyohv~JDs:R:J.xBS$xWbcRjbvs.J:kBnhSzi{bbS$oyf6JonhWBn#R-nNNwj=WBbunhSga#R.',
    picName: 'pic_05',
  },
];